// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"17":"20777591","79":"f93d1978","111":"e8daa4bb","358":"43b736d3"}[chunkId] + ".chunk.css";
};